Namespace 'Common.SimpleTabs'

class Common.SimpleTabs.SimpleTabHeaderView extends Backbone.View
  template: JST['backbone/templates/common/simple_tabs/simple_tab_header']
  tagName: 'li'
  className: 'nav-item'

  initialize: ({tab}) ->
    @tab = tab

  render: ->
    @$el.empty().append @template
      title: @tab.title
      id: @tab.id
    @

  activate: =>
    @$('.nav-link').tab('show')
